// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Rxr","newExpiryDate":"styles_newExpiryDate___iycE","footer":"styles_footer__3Nfae"};